import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { GetDepositTransactionsByIdResponse } from '@/modules/transaction/types'
import { queryDepositTransactionsByIdOptions } from './option'

export default function useQueryDepositTransactionsById(
	id: string,
	options?: UseBaseQueryOptions<GetDepositTransactionsByIdResponse>,
) {
	return useQuery(queryDepositTransactionsByIdOptions(id, options))
}
